import {
  Button,
  TextInput,
  Select as FBSelect,
  Radio,
  Textarea,
} from 'flowbite-react';
import React, { useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../Reducers/store';
import { formatDateInputs } from '../../Utils';
import { fetchCustomOptions, fetchStates } from '../../Actions/CommonFields';
import Select from 'react-select';
import { SelectOption } from '../../Models/SelectOption';
import { Order, OrderEquipment, OrderTypeEnum } from '../../Models/Order';
import { CustomOptionsEnum } from '../../Models/CustomOptionsEnum';
import Loader from '../Common/Loader';
import OrderApi from '../../Api/OrderApi';
import { useNavigate } from 'react-router-dom';

export default function OrderForm() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { customOptions, states } = useAppSelector(
    (state) => state.commonFields
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);

  const [selectedServices, setselectedServices] = useState<
    SelectOption[] | null
  >();
  const [selectedProducts, setselectedProducts] = useState<
    SelectOption[] | null
  >();
  const [selectedEquipments, setselectedEquipments] = useState<
    SelectOption[] | null
  >();
  const [selectedSchedules, setselectedSchedules] = useState<
    SelectOption[] | null
  >();
  const serviceOptionsList = useMemo(() => {
    const list = customOptions
      .filter((x) => x.typeId === CustomOptionsEnum.OrderService)
      .map((t) => ({
        label: t.name,
        value: t.id!,
      })) as SelectOption[];
    return [...list];
  }, [customOptions]);
  const productOptionsList = useMemo(() => {
    const list = customOptions
      .filter((x) => x.typeId === CustomOptionsEnum.OrderProduct)
      .map((t) => ({
        label: t.name,
        value: t.id!,
      })) as SelectOption[];
    return [...list];
  }, [customOptions]);
  const equipmentOptionsList = useMemo(() => {
    const list = customOptions
      .filter((x) => x.typeId === CustomOptionsEnum.OrderEquipment)
      .map((t) => ({
        label: t.name,
        value: t.id!,
      })) as SelectOption[];
    return [...list];
  }, [customOptions]);
  const scheduleOptionsList = useMemo(() => {
    const list = customOptions
      .filter((x) => x.typeId === CustomOptionsEnum.OrderSchedule)
      .map((t) => ({
        label: t.name,
        value: t.id!,
      })) as SelectOption[];
    return [...list];
  }, [customOptions]);

  const [formData, setFormData] = useState<Order>({
    id: 0,
    typeId: null,
    requestedBy: null,
    companyName: null,
    phone: null,
    branchId: null,
    pobox: null,
    email: null,
    emailInvoicesTo: null,
    projectName: null,
    country: null,
    address1: null,
    address2: null,
    city: null,
    stateId: null,
    zipCode: null,
    onsitePoc: null,
    pocphone: null,
    projectDuration: null,
    deliveryDate: null,
    notes: null,
    dateCreated: null,

    orderEquipments: null,
    orderProducts: null,
    orderSchedules: null,
    orderServices: null,
    state: null,
  });

  const getReferences = async () => {
    if (!customOptions.length || !states.length) {
      await Promise.all([
        dispatch(fetchCustomOptions()),
        dispatch(fetchStates()),
      ]);
    }
  };

  useEffect(() => {
    getReferences();
  }, []);

  const handleResetFormValues = () => {
    const values = {
      id: 0,
      typeId: null,
      requestedBy: null,
      companyName: null,
      phone: null,
      branchId: null,
      pobox: null,
      email: null,
      emailInvoicesTo: null,
      projectName: null,
      country: null,
      address1: null,
      address2: null,
      city: null,
      stateId: null,
      zipCode: null,
      onsitePoc: null,
      pocphone: null,
      projectDuration: null,
      deliveryDate: null,
      notes: null,
      dateCreated: null,

      orderEquipments: null,
      orderProducts: null,
      orderSchedules: null,
      orderServices: null,
      state: null,
    };
    setFormData(values as Order);
    setButtonDisabled(false);
  };

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const onSubmit = async (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault();
    setButtonDisabled(true);
    setIsLoading(true);
    if (selectedEquipments) {
      formData.orderEquipments = selectedEquipments.map(function (item) {
        const obj = {
          id: 0,
          orderId: null,
          optionId: item.value,
          option: null,
        } as OrderEquipment;
        return obj;
      });
    } else {
      formData.orderEquipments = [];
    }
    if (selectedProducts) {
      formData.orderProducts = selectedProducts.map(function (item) {
        const obj = {
          id: 0,
          orderId: null,
          optionId: item.value,
          option: null,
        } as OrderEquipment;
        return obj;
      });
    } else {
      formData.orderProducts = [];
    }
    if (selectedSchedules) {
      formData.orderSchedules = selectedSchedules.map(function (item) {
        const obj = {
          id: 0,
          orderId: null,
          optionId: item.value,
          option: null,
        } as OrderEquipment;
        return obj;
      });
    } else {
      formData.orderSchedules = [];
    }
    if (selectedServices) {
      formData.orderServices = selectedServices.map(function (item) {
        const obj = {
          id: 0,
          orderId: null,
          optionId: item.value,
          option: null,
        } as OrderEquipment;
        return obj;
      });
    } else {
      formData.orderServices = [];
    }
    return await OrderApi.addUpdateOrder(formData)
      .then((res) => {
        if (res.data.success) {
          toast.success('Save Success');
          setIsLoading(false);
          setButtonDisabled(false);
          handleResetFormValues();
          navigate('/order-success');
        } else {
          toast.error(res.data.message);
          setIsLoading(false);
          setButtonDisabled(false);
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error('Error: ' + err);
        setIsLoading(false);
        setButtonDisabled(false);
      });
  };

  return (
    <>
      <div className='relative'>
        {isLoading && <Loader />}
        <div className='w-full lg:w-1/2 mx-auto'>
          <div className='w-full'>
            <div className='mx-1 flex items-end justify-center'>
              <div className='flex flex-1 justify-center'>
                <h1 className='text-gray-900 font-bold text-4xl'>Order Fuel</h1>
              </div>
            </div>
          </div>
          <div>
            <div className='container mx-auto p-2'>
              <div className='md:flex no-wrap md:-mx-2 '>
                <div className='w-full'>
                  <div className='bg-white'>
                    <hr className='bg-gray-300 h-[5px]'></hr>
                    <form id='orderForm' onSubmit={onSubmit}>
                      <div className='text-black'>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              I am requesting{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <div className='flex items-center gap-2'>
                              <Radio
                                id='typeId'
                                name='typeId'
                                value={OrderTypeEnum.Order.toString()}
                                checked={
                                  Number(formData.typeId) ===
                                  OrderTypeEnum.Order
                                    ? true
                                    : false
                                }
                                onChange={handleChangeInput}
                                required
                              />
                              <div className='font-bold content-center text-sm'>
                                Order
                              </div>
                            </div>
                            <div className='flex items-center gap-2'>
                              <Radio
                                id='typeId'
                                name='typeId'
                                value={OrderTypeEnum.Quote.toString()}
                                checked={
                                  Number(formData.typeId) ===
                                  OrderTypeEnum.Quote
                                    ? true
                                    : false
                                }
                                onChange={handleChangeInput}
                                required
                              />
                              <div className='font-bold content-center text-sm'>
                                Quote
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Requested by{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='requestedBy'
                              name='requestedBy'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.requestedBy ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div>Billing Information</div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Company Name{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='companyName'
                              name='companyName'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.companyName ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Phone{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='phone'
                              name='phone'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.phone ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Branch ID
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='branchId'
                              name='branchId'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.branchId ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              PO Box
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='pobox'
                              name='pobox'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.pobox ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Email{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='email'
                              name='email'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.email ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Email invoices to{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='emailInvoicesTo'
                              name='emailInvoicesTo'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.emailInvoicesTo ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div>Delivery Information</div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Company or Project Name{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='projectName'
                              name='projectName'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.projectName ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Country
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='country'
                              name='country'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.country ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Address Line 1{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='address1'
                              name='address1'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.address1 ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Address Line 2
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='address2'
                              name='address2'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.address2 ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <div className='flex gap-2'>
                          <div className='flex flex-col text-xl mb-5 w-1/3'>
                            <div className='flex'>
                              <div className='font-bold content-center'>
                                City{' '}
                                <span className='text-gray-400 text-sm'>
                                  (required)
                                </span>
                              </div>
                            </div>
                            <div className='w-full'>
                              <TextInput
                                id='city'
                                name='city'
                                type='text'
                                onChange={handleChangeInput}
                                value={formData.city ?? ''}
                                sizing='md'
                                required
                              />
                            </div>
                          </div>
                          <div className='flex flex-col text-xl mb-5 w-1/3'>
                            <div className='flex'>
                              <div className='font-bold content-center'>
                                State{' '}
                                <span className='text-gray-400 text-sm'>
                                  (required)
                                </span>
                              </div>
                            </div>
                            <div className='w-full'>
                              <FBSelect
                                id='stateId'
                                name='stateId'
                                onChange={handleChangeSelect}
                                value={formData.stateId ?? ''}
                                sizing='md'
                                required
                              >
                                <option value={''}>(Select)</option>
                                {states.map((state) => (
                                  <option key={state.id} value={state.id}>
                                    {state.name}
                                  </option>
                                ))}
                              </FBSelect>
                            </div>
                          </div>
                          <div className='flex flex-col text-xl mb-5 w-1/3'>
                            <div className='flex'>
                              <div className='font-bold content-center'>
                                Zip Code{' '}
                                <span className='text-gray-400 text-sm'>
                                  (required)
                                </span>
                              </div>
                            </div>
                            <div className='w-full'>
                              <TextInput
                                id='zipCode'
                                name='zipCode'
                                type='text'
                                onChange={handleChangeInput}
                                value={formData.zipCode ?? ''}
                                sizing='md'
                                required
                              />
                            </div>
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Onsite POC{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='onsitePoc'
                              name='onsitePoc'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.onsitePoc ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              POC Phone{' '}
                              <span className='text-gray-400 text-sm'>
                                (required)
                              </span>
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='pocphone'
                              name='pocphone'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.pocphone ?? ''}
                              sizing='md'
                              required
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Project Duration
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='projectDuration'
                              name='projectDuration'
                              type='text'
                              onChange={handleChangeInput}
                              value={formData.projectDuration ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Requested Delivery Date
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='deliveryDate'
                              name='deliveryDate'
                              type='date'
                              onChange={handleChangeInput}
                              value={formatDateInputs(
                                formData.deliveryDate?.toString() ?? ''
                              )}
                              sizing='md'
                              pattern='\d{4}-\d{2}-\d{2}'
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Requested Delivery Time
                            </div>
                          </div>
                          <div className='w-full'>
                            <TextInput
                              id='originalQuantity'
                              name='originalQuantity'
                              type='text'
                              onChange={handleChangeInput}
                              //   value={formData.originalQuantity ?? ''}
                              sizing='md'
                            />
                          </div>
                        </div>
                        <div>Order Details</div>
                        <hr className='bg-gray-300 h-[2px]'></hr>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              What service do you need?
                            </div>
                          </div>
                          <div className='w-full'>
                            <Select
                              placeholder='Select all that apply'
                              options={serviceOptionsList}
                              value={selectedServices}
                              isMulti
                              onChange={(e) => {
                                if (e) {
                                  setselectedServices(
                                    e.map((object) => object)
                                  );
                                } else {
                                  setselectedServices(null);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              What product(s) do you need?
                            </div>
                          </div>
                          <div className='w-full'>
                            <Select
                              placeholder='Select all that apply'
                              options={productOptionsList}
                              value={selectedProducts}
                              isMulti
                              onChange={(e) => {
                                if (e) {
                                  setselectedProducts(
                                    e.map((object) => object)
                                  );
                                } else {
                                  setselectedProducts(null);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              What type of Equipment will you be fueling?
                            </div>
                          </div>
                          <div className='w-full'>
                            <Select
                              placeholder='Select all that apply'
                              options={equipmentOptionsList}
                              value={selectedEquipments}
                              isMulti
                              onChange={(e) => {
                                if (e) {
                                  setselectedEquipments(
                                    e.map((object) => object)
                                  );
                                } else {
                                  setselectedEquipments(null);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              What is your requested fill schedule?
                            </div>
                          </div>
                          <div className='w-full'>
                            <Select
                              placeholder='Select all that apply'
                              options={scheduleOptionsList}
                              value={selectedSchedules}
                              isMulti
                              onChange={(e) => {
                                if (e) {
                                  setselectedSchedules(
                                    e.map((object) => object)
                                  );
                                } else {
                                  setselectedSchedules(null);
                                }
                              }}
                            />
                          </div>
                        </div>
                        <div className='flex flex-col text-xl mb-5'>
                          <div className='flex'>
                            <div className='font-bold content-center'>
                              Additional Notes and Instructions
                            </div>
                          </div>
                          <div className='w-full'>
                            <Textarea
                              id='notes'
                              name='notes'
                              onChange={handleChangeTextArea}
                              value={formData.notes ?? ''}
                              rows={4}
                              autoComplete='new-password'
                            />
                          </div>
                        </div>
                      </div>
                      <div className='flex justify-end pt-2'>
                        <Button
                          disabled={buttonDisabled}
                          type='submit'
                          className='buttonMain'
                          form='orderForm'
                        >
                          Submit
                        </Button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
